import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { DetailsOrderClimbRequest, OrderPolishOffRequest, OrderRequest } from '../models/order.model';

@Injectable({
	providedIn: 'root'
})
export class OrderService {

	private url = environment.api + "api/erp/tiendita/order";
	constructor(
		private http: HttpClient,
	) { }

	getOrders() {
		return this.http.get(this.url + "/all");
	}

	addOrder(newOrder: OrderRequest) {
		return this.http.post(this.url, newOrder);
	}

	getOrderDetail(orderId: number) {
		return this.http.get(this.url + "/detail/" + orderId);
	}

	polishOff(order: OrderPolishOffRequest) {
		return this.http.post(this.url + "/polishOff", order);
	}

	climb(orderToClimb: DetailsOrderClimbRequest){
		return this.http.put(this.url + "/" + orderToClimb.orderId, orderToClimb);
	}

	getClimbOrders(){
		return this.http.get(this.url + "/all/climb");
	}

	orderHistory(orderId:number){
		return this.http.get(this.url + "/history/"+orderId);
	}

	orderHistoryDetail(orderId:number){
		return this.http.get(this.url + "/history/detail/"+orderId);
	}
}